import type { CallConversation } from "@/playground/components/DevHome/table/graphql/types";
import type {
  RowData,
  TrackerRowData,
} from "@/playground/components/DevHome/table/pages/conversation_center/components/Table/Table.decl";
import { getType } from "@/playground/components/DevHome/table/states/columns/call_type/call_type.utilities";
import { getCustomer } from "@/playground/components/DevHome/table/states/columns/customer/customer.utilities";
import { getNumber } from "@/playground/components/DevHome/table/states/columns/number/number.utilities";
import { getTranscript } from "@/playground/components/DevHome/table/states/columns/transcript/transcript.utilities";
import { getUser } from "@/playground/components/DevHome/table/states/columns/user/user.utilities";
import { timePortion } from "@/playground/components/DevHome/table/utilities/time";
import { getVirtualAgents } from "./user_with_virtual_agents/user_with_virtual_agents.utilities";

function mapToRowData(
  conversation: CallConversation,
  isSearchTriggered: boolean,
  hasSentimentFeature: boolean
): RowData {
  return {
    type: getType(conversation.type),
    user: getUser(conversation.agents),
    virtualAgents: getVirtualAgents(conversation.virtualAgents),
    number: getNumber(conversation.line),
    customer: getCustomer(conversation.contacts),
    duration: timePortion(conversation.durationInSeconds),
    time: conversation.startTime,
    transcript: getTranscript(conversation),
    callId: conversation.callId,
    predictedCsatScore: conversation.predictedCsatScore ?? null,
    ...(isSearchTriggered
      ? { resultsCount: conversation.transcriptionScope?.totalItems ?? 0 }
      : {}),
    ...(hasSentimentFeature
      ? { sentiment: conversation.sentiment?.overall?.customer ?? null }
      : {}),
  };
}

export function mapToRows(
  conversations: CallConversation[],
  isSearchTriggered: boolean,
  hasSentimentFeature: boolean
) {
  if (isSearchTriggered) {
    return (
      conversations
        // When searching, we remove the ones which do not have any match for the given "text".
        .flatMap((conversation) =>
          conversation.transcriptionScope !== null
            ? [
                mapToRowData(
                  conversation,
                  isSearchTriggered,
                  hasSentimentFeature
                ),
              ]
            : []
        )
    );
  }

  return conversations.map((conversation) =>
    mapToRowData(conversation, isSearchTriggered, hasSentimentFeature)
  );
}

export function mapToRowTrackerData(
  conversation: CallConversation
): TrackerRowData {
  return {
    type: getType(conversation.type),
    user: getUser(conversation.agents),
    number: getNumber(conversation.line),
    customer: getCustomer(conversation.contacts),
    duration: timePortion(conversation.durationInSeconds),
    time: conversation.startTime,
    transcript: getTranscript(conversation),
    callId: conversation.callId,
    // TODO: Do we need to check here?
    sentiment: conversation.sentiment?.overall?.customer ?? null,
  };
}
